/* SNAPTRAP — premium entrance (homepage only). Reveals each section as it scrolls into
   view. Loaded only on template index; never present on product/customizer pages.
   Gated by html.snap-js, which the inline head script adds only when IntersectionObserver
   + :has() + motion are all available. If this class is absent, every section stays fully
   visible — so a JS failure degrades to the plain page, never to hidden content. */
(function () {
  var d = document, h = d.documentElement;
  if ((' ' + h.className + ' ').indexOf(' snap-js ') === -1) return; // matches the CSS gate

  function init() {
    var secs = [].slice.call(d.querySelectorAll('.shopify-section')).filter(function (el) {
      return el.querySelector('.snap-sec') && !el.querySelector('.snap-hero-copy');
    });
    if (!secs.length) { h.className += ' snap-seen'; return; }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('snap-in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });

    secs.forEach(function (s) {
      // anything already in (or near) view on load reveals immediately — the rest on scroll
      if (s.getBoundingClientRect().top < window.innerHeight * 0.92) {
        s.classList.add('snap-in');
      } else {
        io.observe(s);
      }
    });
  }

  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', init);
  else init();
})();
